
import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { cn } from "@/lib/utils";

interface SampleFiltersProps {
  selectedRegion: string;
  selectedLocality: string;
  selectedSegment: string;
  onRegionChange: (value: string) => void;
  onLocalityChange: (value: string) => void;
  onSegmentChange: (value: string) => void;
  className?: string;
}

export const SampleFilters: React.FC<SampleFiltersProps> = ({
  selectedRegion,
  selectedLocality,
  selectedSegment,
  onRegionChange,
  onLocalityChange,
  onSegmentChange,
  className
}) => {
  return (
    <div className={cn("flex gap-4", className)}>
      {/* Region Filter */}
      <Select value={selectedRegion} onValueChange={onRegionChange}>
        <SelectTrigger className="w-[200px]">
          <SelectValue placeholder="Seleccionar región" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="todas">Todas las regiones</SelectItem>
          <SelectItem value="Puna">Puna</SelectItem>
          <SelectItem value="Quebrada">Quebrada</SelectItem>
          <SelectItem value="Valles">Valles</SelectItem>
          <SelectItem value="Yungas">Yungas</SelectItem>
        </SelectContent>
      </Select>

      {/* Locality Filter */}
      <Select value={selectedLocality} onValueChange={onLocalityChange}>
        <SelectTrigger className="w-[200px]">
          <SelectValue placeholder="Seleccionar localidad" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="todas">Todas las localidades</SelectItem>
          <SelectItem value="San Salvador">San Salvador</SelectItem>
          <SelectItem value="Tilcara">Tilcara</SelectItem>
          <SelectItem value="Purmamarca">Purmamarca</SelectItem>
          <SelectItem value="Termas">Termas</SelectItem>
        </SelectContent>
      </Select>

      {/* Segment Filter */}
      <Select value={selectedSegment} onValueChange={onSegmentChange}>
        <SelectTrigger className="w-[200px]">
          <SelectValue placeholder="Seleccionar segmento" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="todos">Todos los segmentos</SelectItem>
          <SelectItem value="A">A</SelectItem>
          <SelectItem value="B">B</SelectItem>
          <SelectItem value="C">C</SelectItem>
          <SelectItem value="D">D</SelectItem>
          <SelectItem value="E">E</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};
